import React from 'react'

const Editor = () => {
  return (
    <div>Editor</div>
  )
}

export default Editor